// import { BASE_URL } from '@/api/url';
// import BaseFuncApi from '@/api/base/commonFunc-api';
// import Enum from '@/enum/enum';
import UserGroupClient from '@/api/userGroup/user-group-client';
const userGroupClient = new UserGroupClient();
export default {
    addUserToGroup: async function (context, payload) {
        var result = await userGroupClient.postAsync({
            url: `${userGroupClient.url}`,
            data: payload
        }, true);
        if (result && result.access_token) {
            return result;
        }
        return result;
    },
}